let gtmScriptElement: HTMLScriptElement | null = null;

export function loadGTM(gtmId: string): void {
	if (gtmScriptElement) return;

	// dataLayer initialisieren
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		"gtm.start": Date.now(),
		event: "gtm.js",
	});

	// GTM Script einfuegen
	const script = document.createElement("script");
	script.async = true;
	script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
	document.head.appendChild(script);
	gtmScriptElement = script;
}

export function removeGTM(): void {
	if (gtmScriptElement) {
		gtmScriptElement.remove();
		gtmScriptElement = null;
	}

	// dataLayer leeren
	window.dataLayer = [];

	// GTM-Cookies entfernen
	const cookies = document.cookie.split(";");
	for (const cookie of cookies) {
		const name = cookie.split("=")[0].trim();
		if (name.startsWith("_ga") || name.startsWith("_gid") || name.startsWith("_gat")) {
			document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
		}
	}
}
